<template>
  <HeaderV />
  <main class="main">
  <SectionOne />
  <SectionTwo />
  </main>
  <FooterV />
</template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import HeaderV from "@/components/Landing/HeaderV.vue";
    import SectionOne from "@/components/Landing/SectionOne.vue";
    import SectionTwo from "@/components/Landing/SectionTwo.vue";
    import FooterV from "@/components/Landing/FooterV.vue";
  
    export default defineComponent({
      name: "UsagerPaiementPage",
      components: {
        SectionTwo,
        HeaderV,
        FooterV,
        SectionOne
      },
    });
  </script>